import { Box } from '@chakra-ui/react';
import { humanizeDurationForChart } from 'views/main/organization/analytics-v3/helpers';
import { useGetAnalyticsXTTRVsTime } from 'views/main/organization/analytics-v3/hooks/useGetAnalyticsData';
import Empty from 'views/main/organization/analytics-v3/icons/empty';
import Line from '../../../Charts/Line';
import { LineChartLoading } from '../../../Charts/Line/Loading';
import Error from 'views/main/organization/analytics-v3/components/Error';
import { AxiosError } from 'axios';

export function XTTRVsTime({
  selectedMetricTypeLabel,
  isOrgAnalytics,
}: {
  selectedMetricTypeLabel: string;
  isOrgAnalytics: boolean;
}) {
  const { data, isLoading, isError, refetch, error } = useGetAnalyticsXTTRVsTime({
    isOrgAnalytics,
  });
  if (isError) {
    return (
      <Box position="relative" height={282}>
        <Error
          onRefreshClick={refetch}
          errorMessage={(error as AxiosError).response?.data?.message}
        />
      </Box>
    );
  }
  if (isLoading) return <LineChartLoading />;
  if (!data) return null;
  const isEmpty = data?.dates.length === 0;
  if (isEmpty) return <Empty />;
  return (
    <Line
      title={`${selectedMetricTypeLabel} TTR over time`}
      data={data}
      format={value => humanizeDurationForChart(value, 1)}
    />
  );
}
